export default "__VITE_PUBLIC_ASSET__1798bec7__"